<div class="tw-w-full tw-relative tw-font-lexend tw-rounded-3" [ngClass]="customStyling" (click)="clickToNavigate()">
  <img [src]="imageUrl" class="tw-w-full  tw-relative tw-z-[1] tw-object-cover">
  <div class="tw-w-full tw-absolute tw-inset-0 tw-z-[2] tw-flex tw-flex-col tw-items-start tw-justify-start tw-px-4 tw-pt-4">
    <div class="tw-flex tw-justify-end tw-items-center tw-mb-3">
      <cs-icon class="tw-w-8 tw-h-8" [iconName]="'https://cdn.cureskin.com/app/img/rebranded_click-icon.svg'"></cs-icon>
    </div>
    <h1 class="tw-text-500 tw-font-medium tw-leading-6 tw-mb-3" [innerHTML]="bannerText"></h1>
    <p class="tw-text-100 tw-font-medium tw-mb-">{{ bannerSubText }}</p>
  </div>
</div>
